import * as api from './../../api/api.service';
import * as rfpsApi from './../../api/rfps/rfp.service';

export default function PricingModelFactory(
  $rootScope,
  $window,
  $bsModal,
  api: api.IApiService
) {
  'ngInject';

  return {
    // This exists, not as a substitute for an API call, but as something which brings up some UI in the form of a
    // dialog which is needed from multiple spots.

    /**
     * Call this with the old rfpInfo (flag off)
     *
     * @param {[type]} rfpInfo  [description]
     * @param {number} sellerId [description]
     */
    create: function (rfpInfo, sellerId: number) {
      let defaultSellerId = rfpInfo.offer.seller.id;
      let categoryId = rfpInfo.productCategory.id;
      let rfpId = rfpInfo.requestId;

      sellerId = sellerId || rfpInfo.offer.seller.id;

      this.openModal(rfpId, categoryId, sellerId);
    },

    /**
     * Call this with the new rfp (flag on)
     *
     * @param {rfpsApi.RfpVersionTwo} rfp      [description]
     * @param {number}                     sellerId [description]
     */
    createWithRfp(rfp: rfpsApi.RfpVersionTwo, sellerId: number) {
      this.openModal(rfp.id, rfp.category.id, sellerId);
    },

    openModal(rfpId, categoryId, sellerId) {
      let newPricingModelModal;
      let dialogScope = $rootScope.$new();

      dialogScope.form = {
        pricingModelName: ''
      };

      dialogScope.createAndContinue = () => {
        api.sellers
          .createPricingModel(
            sellerId,
            categoryId,
            dialogScope.form.pricingModelName
          )
          .then((response) => {
            newPricingModelModal.hide();
            $window.location = `/aptitude/seller/SellerEditPricingModel?modelId=${response}&rfpId=${rfpId}`;
          });
      };

      newPricingModelModal = $bsModal({
        template: `<div class="modal" tabindex="-1" role="dialog">
                     <div class="modal-dialog">
                       <div class="modal-content">
                         <div class="modal-header">
                           <button type="button" class="close" aria-label="Close" ng-click="$hide()"><i class="fa fa-times"></i></button>
                           <h3 class="modal-title">Create New Pricing Model</h3>
                         </div>
                         <div class="modal-body">
                           <div class="form-group">
                             <label for="pricing-model-name">The new pricing model name is:</label>
                             <input id="pricing-model-name" type="text" ng-model="form.pricingModelName" />
                           </div>
                         </div>
                         <div class="modal-footer">
                           <button type="button" class="btn btn-primary" ng-click="createAndContinue()">Create</button>
                         </div>
                       </div>
                     </div>
                   </div>`,
        placement: 'center',
        scope: dialogScope
      });
    }
  };
}
